// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3ewFu","topBottomGutter":"Layout_topBottomGutter__3h7Yq"};